import "./ServiceCostTab.css";

import { TextWithLineBreaks } from "../../../Components/TextWithLineBreaks";

// =====================================
//  Edit plan card data here
// =====================================

const PLAN_CARDS = [
    {
        name: "Basic",
        badgeClass: "sct-badge-blue",
        price: "₩135만원~",
        priceNote: "(VAT 별도 / 대행료 1회)",
        typeLabel: "KINDLE ONLY",
        typeLabelClass: "sct-type-label-blue",
        typeTitle: "킨들 전자책 단독",
        typeDesc: "KDP + Kindle · 저자 계정 등록",
        checkClass: "sct-check-blue",
        features: [
            { text: "KDP 계정 & Tax Profile 최적화 설정" },
            { text: "전자책 내지 / 표지 제작\n(KDP 전용 규격 · 시안 3개 · 수정 1회)" },
            { text: "메타데이터 / 키워드 / 도서 소개 최적화" },
            { text: "Kindle Previewer 포함 품질 최종 검수" },
            { text: "글로벌 출간 및 유통 등록" },
            { text: "Author Central 구축 가이드 PDF 제공" },
            { text: "수정 1회 · 30일 사후 지원" },
        ],
        accountTag: "저자 계정 사용",
    },
    {
        name: "Pro",
        badgeClass: "sct-badge-orange",
        price: "₩340만원~",
        priceNote: "(VAT 별도)",
        typeLabel: "KINDLE + POD",
        typeLabelClass: "sct-type-label-orange",
        typeTitle: "전자책+종이책",
        typeDesc: "KDP + Paperback · 저자 계정 등록",
        checkClass: "sct-check-orange",
        features: [
            { text: "Basic 모든 항목 포함", bold: true },
            { text: "종이책 내지 조판 (6×9 기준)" },
            { text: "종이책 전문 표지 디자인\n(Spine 포함 · 시안 2개 · 수정 1회)" },
            { text: "Author Central + SEO / AMS Ads\n초기 설정 (마케팅 가이드 패키지 PDF 제공)" },
            { text: "수정 2회 · 60일 사후 지원" },
        ],
        accountTag: "저자 계정 사용",
    },
];

// =====================================
//  Edit additional options data here
// =====================================

const ADDITIONAL_OPTIONS = [
    {
        title: "옵션1. 계정 사용 방식",
        type: "table",
        rows: [
            { label: "출판사 계정 사용 (에이콘 계정 등록)", value: "순수익 20% 수수료" },
        ],
    },
    {
        title: "옵션2. 번역 옵션 (다중 선택 가능)",
        type: "cards",
        note: "영어·일본어 동시 진행 시 각 언어별 별도 과금",
        cards: [
            { title: "US 영어 번역 추가", desc: "한국어 원고 → English (₩60 / 한글 1자)" },
            { title: "JP 일본어 번역 추가", desc: "한국어 원고 → 日本語 (₩90 / 한글 1자)" },
        ],
    },
];

// =====================================

function PlanCard({ plan }) {
    return (
        <div className="sct-plan-card">
            {/* Badge */}
            <span className={`sct-badge ${plan.badgeClass}`}>{plan.name}</span>

            {/* Price */}
            <div className="sct-plan-price">{plan.price}</div>
            <div className="sct-plan-price-note">{plan.priceNote}</div>

            <div className="sct-divider" />

            {/* Type block */}
            <div className={`sct-type-label ${plan.typeLabelClass}`}>{plan.typeLabel}</div>
            <div className="sct-type-title">{plan.typeTitle}</div>
            <div className="sct-type-desc">{plan.typeDesc}</div>

            <div className="sct-divider" />

            {/* Features */}
            <ul className="sct-features">
                {plan.features.map((feature, i) => (
                    <li key={i} className="sct-feature-item">
                        <img
                            src="/images/check.png"
                            alt="check"
                            className={`sct-check ${plan.checkClass}`}
                        />
                        <span className={`sct-feature-text${feature.bold ? " bold" : ""}`}>
                            <TextWithLineBreaks text={feature.text} />
                        </span>
                    </li>
                ))}
            </ul>

            {/* Account tag */}
            {plan.accountTag && (
                <div className="sct-account-tag">{plan.accountTag}</div>
            )}
        </div>
    );
}

function OptionSection({ option }) {
    return (
        <div className="sct-option-section">
            <div className="sct-option-subtitle">{option.title}</div>

            {option.type === "table" && (
                <div className="sct-option-table">
                    {option.rows.map((row, i) => (
                        <div key={i} className="sct-option-table-row">
                            <span className="sct-option-table-label">{row.label}</span>
                            <span className="sct-option-table-value">{row.value}</span>
                        </div>
                    ))}
                </div>
            )}

            {option.type === "cards" && (
                <>
                    {option.note && (
                        <div className="sct-option-note">· {option.note}</div>
                    )}
                    <div className="sct-option-cards-row">
                        {option.cards.map((card, i) => (
                            <div key={i} className="sct-option-card">
                                <div className="sct-option-card-title">{card.title}</div>
                                <div className="sct-option-card-desc">{card.desc}</div>
                            </div>
                        ))}
                    </div>
                </>
            )}
        </div>
    );
}

function ServiceCostTab() {
    return (
        <div className="service-cost-tab">

            <div className="service-cost-tab-title">비용</div>

            {/* Plan cards */}
            <div className="sct-plans-row">
                {PLAN_CARDS.map((plan) => (
                    <PlanCard key={plan.name} plan={plan} />
                ))}
            </div>

            {/* Additional options */}
            <div className="sct-options">
                <div className="sct-options-title">추가 옵션</div>
                <div className="sct-options-wrapper">
                    {ADDITIONAL_OPTIONS.map((option, i) => (
                        <OptionSection key={i} option={option} />
                    ))}
                </div>
            </div>

            <div className="sct-bottom-spacer" />
        </div>
    );
}

export default ServiceCostTab;
